import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useFormContext } from 'react-hook-form';
import { addErrorToast, clearMessages } from 'messages';
import { getMessage } from 'util/locale';
import { FormData } from '../../types';

export const ErrorHandler = () => {
  const { formState: { errors } } = useFormContext<FormData>();
  const dispatch = useDispatch();

  useEffect(() => {
    if (errors?.fields?.some((field) => field?.selectedRecommendation?.message)) {
      dispatch(addErrorToast(getMessage('bulk-fvss-script-generation-no-plan-generated-error')));
    }
    return () => { dispatch(clearMessages()); };
  }, [errors.fields, dispatch]);

  return null;
};
